import curry from "ramda/es/curry";
/**
 * Utility function used to create a breadcrumb event that will be then sent to apm-server.
 *
 * @documented
 * @category APM
 * @import import { createEventDescription } from '@gef-ui/apm/instruments/utils/description'
 * @param {String} type - instrument type name
 * @param {Object} data - any data that you wan't to pass to apm-server
 * @example
 *
 * const { category, description, timestamp } = createEventDescription('REDUX', data);
 *
 */ export const createEventDescription = curry((type, data)=>({
        category: type,
        description: data,
        timestamp: Date.now()
    }));
